import { faClone } from '@fortawesome/free-regular-svg-icons';
import { faMinusSquare, faPlusSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import unimedLogo from '../../../assets/images/unimed-logo-transparente.png';
import TypographyAccessibility from '../../../components/Accessibility/TypographyAccessibility';
import { Carteirinha } from '../../../interfaces/entities/Carteirinha';
import './styles.css';
import { sxBeneficiarioInfo, sxBeneficiarioInfoLabel, sxBeneficiarioMoreInfo, sxBeneficiarioMoreInfoLabel, sxIconButton, sxInfoBeneficiario, sxInfoHeaderCartao, sxLabelInfoBeneficiario, sxNumeroCartao } from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';


export interface CardFrontProps {
  getSelectBeneficiario: () => Carteirinha;
  toggleMoreInfo?: () => void;
  showMoreInfo: boolean;
}

const CardFront: React.FC<CardFrontProps> = ({ getSelectBeneficiario, toggleMoreInfo, showMoreInfo }) => {
  
  const accessibility = useAccessibility();
  const isDesktop = useMediaQuery('(min-width: 1200px)');

  function copiarParaClipboard() {
    navigator.clipboard.writeText(getSelectBeneficiario().numeroCarteirinha.replace(/\s/g, ""));
  };

  const [iconColor, setIconColor] = useState('white');


  return (
    <div className='container-cartao-frente'>
      <div className='cartao-frente-header'>
        <img src={unimedLogo} alt='logo unimed' />
        <Typography sx={sxInfoHeaderCartao}>{getSelectBeneficiario().nomeDoPlano}</Typography>
        <Typography sx={sxInfoHeaderCartao}>{getSelectBeneficiario().tipoPlano}</Typography>
      </div>
      <div className='cartao-frente-body'>
        <div className='container-numero-cartao'>
          <Typography sx={sxNumeroCartao}>{getSelectBeneficiario().numeroCarteirinha}</Typography>
          <IconButton
            sx={sxIconButton}
            aria-label='Copiar número do cartão'
            onClick={() => copiarParaClipboard()}
            onMouseEnter={() => setIconColor('white')} // Altera a cor do ícone ao passar o mouse por cima
            onMouseLeave={() => setIconColor('white')}   // Retorna a cor do ícone ao remover o mouse
          >
            <FontAwesomeIcon color={iconColor} flip='vertical' className='fa-flip-horizontal' icon={faClone} />
          </IconButton>
        </div>
        <div>
          <Typography sx={sxBeneficiarioInfo}>{getSelectBeneficiario().nomeBeneficiario}</Typography>
          <Typography sx={sxBeneficiarioInfoLabel}>Nome do Beneficiário</Typography>
        </div>
        <div className='container-info-cartao'>

          <div className='container-cartao-info-colunas'>

            <div>
              <Typography sx={sxBeneficiarioInfo}>{getSelectBeneficiario().acomodacao}</Typography>
              <Typography sx={sxBeneficiarioInfoLabel}>Acomodação</Typography>
            </div>
            <div>
              <Typography sx={sxBeneficiarioInfo}>{getSelectBeneficiario().plano}</Typography>
              <Typography sx={sxBeneficiarioInfoLabel}>Plano</Typography>
            </div>
            <div>
              <Typography sx={sxBeneficiarioInfo}>{getSelectBeneficiario().abrangencia}</Typography>
              <Typography sx={sxBeneficiarioInfoLabel}>Abrangência</Typography>
            </div>
          </div>
          <div className='container-cartao-info-colunas'>
            <div>
              <Typography sx={sxBeneficiarioInfo}>{getSelectBeneficiario().validade}</Typography>
              <Typography sx={sxBeneficiarioInfoLabel}>Validade</Typography>
            </div>
            <div>
              <Typography sx={sxBeneficiarioInfo}>{getSelectBeneficiario().redeDeAtendimento}</Typography>
              <Typography sx={sxBeneficiarioInfoLabel}>Rede de Atendimento</Typography>
            </div>
            <div>
              <Typography sx={sxBeneficiarioInfo}>{getSelectBeneficiario().atendimento}</Typography>
              <Typography sx={sxBeneficiarioInfoLabel}>Atend.</Typography>
            </div>
          </div>
        </div>
        <div>
          <Typography sx={sxBeneficiarioInfo}>{getSelectBeneficiario().segmentacaoAssistencialPlano}</Typography>
          <Typography sx={sxBeneficiarioInfoLabel}>Segmentação Assistencial do Plano</Typography>
        </div>
      </div>
      {isDesktop &&
        <>
          <div className='more-info-container'>
            <button style={accessibility.contrastStyle} className="more-info-button" onClick={toggleMoreInfo}>
              <FontAwesomeIcon icon={!showMoreInfo ? faPlusSquare : faMinusSquare} className='fa-icon-plus-square' />&nbsp;&nbsp;
              <u>{`${!showMoreInfo ? 'Mais' : 'Ocultar'} informações`}</u>
            </button>
            {showMoreInfo &&
              <div className={`more-infos-card ${showMoreInfo ? 'openCard' : 'closeCard'}`}>
                <div className='container-more-infos-card'>
                  <div className='more-info-card-columns'>
                    <div>
                      <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().dtNasc}</Typography>
                      <Typography sx={sxBeneficiarioMoreInfoLabel}>Data de Nascimento</Typography>
                    </div>
                    <div>
                      <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().coberturaParcialTemporaria}</Typography>
                      <Typography sx={sxBeneficiarioMoreInfoLabel}>Cobertura Parcial Temporária</Typography>
                    </div>
                  </div>
                  <div className='more-info-card-columns'>
                    <div>
                      <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().vigenciaPlano}</Typography>
                      <Typography sx={sxBeneficiarioMoreInfoLabel}>Vigência do Plano</Typography>
                    </div>
                    <div>
                      <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().via}</Typography>
                      <Typography sx={sxBeneficiarioMoreInfoLabel}>Via</Typography>
                    </div>
                  </div>
                </div>
                <div>
                  <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().contratante}</Typography>
                  <Typography sx={sxBeneficiarioMoreInfoLabel}>Contratante</Typography>
                </div>
              </div>
            }
          </div>
          <div className='container-info-beneficiario'>
            <div className='info-beneficiario'>
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Nome do beneficiário:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().nomeBeneficiario.toLowerCase()}</TypographyAccessibility>
            </div>
            <div className='info-beneficiario'>
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Acomodação:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().acomodacao.toLowerCase()}</TypographyAccessibility>
            </div>
            <div className='info-beneficiario'>
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Plano:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().plano.toLowerCase()}</TypographyAccessibility>
            </div>
            <div className='info-beneficiario'>
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Vigência do plano:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().vigenciaPlano}</TypographyAccessibility>
            </div>
            <div className='info-beneficiario'>
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Abrangência:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().abrangencia.toLowerCase()}</TypographyAccessibility>
            </div>
          </div>
        </>
      }
    </div>
  )
}

export default CardFront